import * as React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';

const PlatformIntro = () => {
	return (
		<Container
			maxWidth="lg"
			sx={{
				py: { xs: 6, sm: 8 },
			}}
		>
			<Box
				sx={{
					display: 'grid',
					gridTemplateColumns: { xs: '1fr', md: '3fr 2fr' },
					gap: { xs: 4, md: 8 },
					alignItems: 'center',
				}}
			>
				<Box>
					<Typography
						variant="h2"
						sx={{
							fontSize: {
								xs: '1.75rem',
								sm: '2.5rem',
								md: '3rem',
							},

							fontWeight: 500,

							lineHeight: 1.2,
							mb: 3,
						}}
					>

						Lenz Platform – tulevaisuuden resursointi on täällä.

					</Typography>

					<Typography
						variant="body1"
						sx={{
							fontSize: {
								xs: '1rem',
								sm: '1.1rem',
								md: '1.2rem',
							},
							mb: 3,
							color: 'text.secondary',
						}}
					>
						Lenz Platform on tekoälypohjainen työkalu, joka tekee ad
						hoc -avunsaannista vaivatonta yritysten päättäjille. Sen
						kehittynyt algoritmi tunnistaa talentpoolistamme

						nopeasti lupaavimmat nuoret talentit vastaamaan juuri
						sinun tarpeisiisi – perinteisen pitkän kokemuksen sijaan
						korostamme tekijöiden potentiaalia, persoonaa,
						luovuutta, kiinnostusta ja kunnianhimoa.
					</Typography>

					<Typography
						variant="body1"
						sx={{
							fontSize: {
								xs: '1rem',
								sm: '1.1rem',
								md: '1.2rem',
							},
							color: 'text.secondary',
						}}
					>

						Lenz vastaa talenttien laadusta, joten voit tehdä
						päätöksen huoletta. Onnistuneen projektin jälkeen
						sinulla on mahdollisuus rekrytoida huippuosaaja tiimisi
						tai jatkaa joustavalla konsultointimallilla niin pitkään
						kuin haluat.
					</Typography>
				</Box>

				<Box
					sx={{
						position: 'relative',
						width: '100%',
						height: { xs: '250px', sm: '400px', md: '500px' },
					}}
				>
					<Box
						component="img"
						src="/images/platform_landing/Platform_kuvitus1.png"
						alt="Lenz Platform illustration"
						sx={{
							width: '100%',
							height: '100%',
							objectFit: 'contain',
						}}
					/>
				</Box>
			</Box>
		</Container>
	);
};

export default PlatformIntro;
